import React from "react"

import { isInPosDevice } from "utils"
import { OrdersGroupPrintButton, OrdersSetAsViewedButton } from "components"
import PoMakeReportButton from "../PaidOrders/PoMakeReportButton"
import PoGroupLabelPrintButton from "../PaidOrders/PoGroupLabelPrintButton"
import PoGroupInvoicePrintButton from "../PaidOrders/PoGroupInvoicePrintButton"
import classes from "./OhFooter.module.scss"

const OhFooter = (props) => {
  const {
    setOrders,
    selectedOrders,
    setSelectedOrders
  } = props

  const showGroupPrintButton =
    !isInPosDevice()

  const showLabelPrintButton =
    !isInPosDevice()

  const showInvoicePrintButton =
    !isInPosDevice()

  const showExcelPrintButton =
    !isInPosDevice()

  return (
    <div className={classes["footer"]}>
      <OrdersSetAsViewedButton
        orderStatus="delivered"
        setOrders={setOrders}
      />

      {
        showLabelPrintButton &&
        <PoGroupLabelPrintButton
          selectedOrders={selectedOrders}
        />
      }

      {
        showGroupPrintButton &&
        <OrdersGroupPrintButton
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
        />
      }

      {
        showInvoicePrintButton &&
        <PoGroupInvoicePrintButton
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
        />
      }

      {
        showExcelPrintButton &&
        <PoMakeReportButton
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
        />
      }
    </div>
  )
}

export default OhFooter